<div class="page-content container">
  <div class="login shadow-sm" *ngIf="!showRoles">
    <div class="login-header">
      <!-- <span>Пријава корисника</span> -->
      <span>{{ translationManager.getTranslation('Пријава корисника') }}</span>
    </div>
    <div class="alert alert-info">
      <!-- <span><i class="fa fa-info-circle"></i>Молимо унесите валидне креденцијале за пријаву на систем</span> -->
      <span><i
          class="fa fa-info-circle"></i>{{ translationManager.getTranslation('Молимо унесите валидне креденцијале за пријаву на систем') }}</span>
    </div>
    <div class="login-body">
      <div class="page-part" *ngIf="error">
        <div class="alert alert-danger"><span><i class="fa fa-exclamation-triangle"></i>{{ error }}</span></div>
      </div>
      <div class="page-part">
        <div class="app-form-element"
          [ngClass]="{ 'app-form-element-error': form.elements['username'].error.required || form.elements['username'].error.invalid }">
          <!-- <label>Корисничко име</label> -->
          <label>{{ translationManager.getTranslation('Корисничко име') }}</label>
          <div class="app-form-element-content">
            <input type="text" name="username" [(ngModel)]="form.elements['username'].value" maxlength="250"
              (keyup.enter)="login()" (blur)="updateForgetPasswordButton()">
          </div>
          <div class="app-form-element-error-panel">
            <span *ngIf="form.elements['username'].error.required"><i
                class="fas fa-times-circle"></i>{{ translationManager.getTranslation('Поље је обавезно за унос') }}</span>
          </div>
        </div>
      </div>
      <div class="page-part">
        <div class="app-form-element"
          [ngClass]="{ 'app-form-element-error': form.elements['password'].error.required || form.elements['password'].error.invalid }">
          <!-- <label>Лозинка</label> -->
          <label>{{ translationManager.getTranslation('Лозинка') }}</label>
          <div class="app-form-element-content">
            <input type="password" name="password" [(ngModel)]="form.elements['password'].value" maxlength="500"
              (keyup.enter)="login()">
          </div>
          <div class="app-form-element-error-panel">
            <!-- <span *ngIf="form.elements['password'].error.required"><i
                                class="fas fa-times-circle"></i>Поље
                            је
                            обавезно
                            за
                            унос</span> -->

            <span *ngIf="form.elements['password'].error.required"><i
                class="fas fa-times-circle"></i>{{ translationManager.getTranslation('Поље је обавезно за унос') }}</span>

          </div>
        </div>
      </div>

      <div class="page-part" *ngIf="isForgetPasswordEnabled">
        <span>
          {{ translationManager.getTranslation('Заборавили сте лозинку?') }}
          <ng-container *ngIf="isForgetPasswordEnabled; else plainText">
            <a href="#" style="color: blue;" (click)="forgetPassword()">
              {{ translationManager.getTranslation('Кликните овде') }}
            </a>
          </ng-container>
          <ng-template #plainText>
            {{ translationManager.getTranslation('Кликните овде') }}
          </ng-template>
          {{ translationManager.getTranslation('да би је ресетовали.') }}
        </span>
      </div>
      


      <div class="app-form-element-buttons">
        <!-- <button class="btn btn-success" (click)="login()"><i class="fa fa-check mr-2"></i>
                    Улогуј се</button> -->
        <button class="btn btn-success" (click)="login()"><i class="fa fa-check mr-2"></i>
          {{ translationManager.getTranslation('Улогуј се') }}</button>

      </div>
    </div>
  </div>
  <div class="login shadow-sm" *ngIf="showRoles">
    <div class="login-header">
      <span>{{ translationManager.getTranslation('Пријава корисника') }}</span>
    </div>
    <div class="alert alert-info">
      <span><i
          class="fa fa-info-circle"></i>{{ translationManager.getTranslation('Молимо одаберите ролу/групу којој приступата на систему') }}</span>
    </div>
    <!-- <div class="app-table-panel"> -->
    <div class="app-table">
      <table class="table table-striped text-dark-m1">
        <thead>
          <tr class="bgc-primary-tp2 text-white">
            <th>
              {{ translationManager.getTranslation('Назив улоге/групе') }}
            </th>
            <th style="width: 100px" class="right">{{ translationManager.getTranslation('Акције') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of dataUser.rolesNameAndId">
            <td>{{item.name}}</td>

            <td class="right">
              <div class="table-actions">
                <a href="javascript:;" (click)="LogInWithRole(item.id)"
                  [title]="translationManager.getTranslation('Пријави се')">
                  <i class="fas fa-sign-in-alt"></i>
                </a>
              </div>
            </td>

          </tr>
        </tbody>
      </table>
      <div class="no-content" *ngIf="!dataUser.rolesNameAndId || dataUser.rolesNameAndId.length == 0">
        <span>{{ translationManager.getTranslation('Без података') }}</span>
      </div>

    </div>

    <!-- </div> -->

  </div>

</div>
